import { render, staticRenderFns } from "./ModifiedTip.vue?vue&type=template&id=b549c8c2&scoped=true&"
import script from "./ModifiedTip.vue?vue&type=script&lang=ts&"
export * from "./ModifiedTip.vue?vue&type=script&lang=ts&"
import style0 from "./ModifiedTip.vue?vue&type=style&index=0&id=b549c8c2&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b549c8c2",
  null
  
)

export default component.exports